import { render } from "./LittleRedDot.vue?vue&type=template&id=878b37d2"
import script from "./LittleRedDot.vue?vue&type=script&lang=js"
export * from "./LittleRedDot.vue?vue&type=script&lang=js"

import "./LittleRedDot.vue?vue&type=style&index=0&id=878b37d2&lang=css"
script.render = render

export default script